import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1333615b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "reference"
}
const _hoisted_2 = { class: "reference-box" }
const _hoisted_3 = { class: "reference-box-show" }
const _hoisted_4 = { class: "reference-box-show-name" }
const _hoisted_5 = {
  key: 1,
  class: "reply"
}
const _hoisted_6 = { class: "reply-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_8 = { class: "reply-box-show" }

import { toRefs } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-reference-or-reply',
  props: {
  replyOrReference: {
    type: Object,
    default: () => ({}),
  },
  isH5: {
    type: Boolean,
    default: false,
  },
},
  emits: ['resetReplyOrReference'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { replyOrReference, isH5 } = toRefs(props);
const close = () => {
  emit('resetReplyOrReference');
};

return (_ctx: any,_cache: any) => {
  return (_unref(replyOrReference)?.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      _unref(replyOrReference)?.show === 'reference' && 'message-input-reference',
      _unref(replyOrReference)?.show === 'reply' && 'message-input-reply',
      _unref(isH5) && _unref(replyOrReference)?.show === 'reference' && 'message-input-reference-h5',
      _unref(isH5) && _unref(replyOrReference)?.show === 'reply' && 'message-input-reply-h5',
    ])
      }, [
        (_unref(replyOrReference)?.show === 'reference')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(replyOrReference)?.message?.nick ? _unref(replyOrReference)?.message?.nick : _unref(replyOrReference)?.message?.from) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(replyOrReference)?.content), 1)
                ]),
                _createElementVNode("label", {
                  class: "icon icon-cancel",
                  onClick: close
                })
              ])
            ]))
          : (_unref(replyOrReference)?.show === 'reply')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_unref(replyOrReference)?.message?.nick ? _unref(replyOrReference)?.message?.nick : _unref(replyOrReference)?.message?.from) + _toDisplayString(_unref(isH5) ? ':' : ''), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(replyOrReference)?.content), 1)
                  ]),
                  _createElementVNode("label", {
                    class: "icon icon-cancel",
                    onClick: close
                  })
                ])
              ]))
            : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})